import React, { useEffect, useRef, useState } from "react";

const PacienteableInfo = ({paciente, disabled, onChange, errors}) => {
    const fechaNacimeintoRef = useRef(null);
    const sexoRef = useRef(null);
    const grupoSanguineoRef = useRef(null);

    const [edad, setEdad] = useState(null);
    const [editando, setEditando] = useState({
        fecha_nacimiento: false,
        sexo: false,
        grupo_sanguineo: false,
    });

    const toggleEdit = (prop) => setEditando({
        fecha_nacimiento: false,
        sexo: false,
        grupo_sanguineo: false,
        [prop]: !editando[prop],
    });

    useEffect(() => {
        if (disabled) {
            setEditando({
                fecha_nacimiento: false,
                sexo: false,
                grupo_sanguineo: false,
            });
        }
    }, [disabled]);

    useEffect(() => {
        if (editando.fecha_nacimiento && fechaNacimeintoRef.current) {
            fechaNacimeintoRef.current.focus();
        }

        if (editando.sexo && sexoRef.current) {
            sexoRef.current.focus();
        }

        
        if (editando.grupo_sanguineo && grupoSanguineoRef.current) {
            grupoSanguineoRef.current.focus();
        }
    }, [editando]);

    useEffect(() => {
        if (!paciente?.fecha_nacimiento) {
            setEdad(null);
            return;
        }

        const hoy = new Date();
        const nacimiento = new Date(paciente?.fecha_nacimiento);

        let edad = hoy.getFullYear() - nacimiento.getFullYear();
        const mes = hoy.getMonth() - nacimiento.getMonth();
        const dia = hoy.getDate() - nacimiento.getDate();

        // Ajustar si aún no ha cumplido años este año
        if (mes < 0 || (mes === 0 && dia < 0)) {
            edad -= 1;
        }

        setEdad(edad);
    }, [paciente?.fecha_nacimiento]);

    return <>
        <div className="col">
            {editando.fecha_nacimiento
                ? <input ref={fechaNacimeintoRef} className="form-control" type="date" value={paciente?.fecha_nacimiento ?? ''} onChange={(e) => onChange({...paciente, fecha_nacimiento: e.target.value})} onBlur={() => toggleEdit('fecha_nacimiento')} />
                : <span onClick={() => toggleEdit('fecha_nacimiento')} className="clickable"><i className="far fa-user"></i> {edad} {edad ? 'años' : ''}</span>
            }

            {(errors && errors['paciente.fecha_nacimiento']) && (
                <small className='help-blockParams form-Text'>
                    Este Campo es requerido.<br/>
                </small>
            )}
        </div>
        <div className="col">
            {editando.sexo
                ? <select ref={sexoRef} className="form-control" value={paciente?.sexo ?? ''} onChange={(e) => onChange({...paciente, sexo: e.target.value})} onBlur={() => toggleEdit('sexo')}>
                    {!paciente?.sexo && <option value="">Seleccionar...</option>}
                    <option value="M">Masculino</option>
                    <option value="F">Femenino</option>
                </select>
                :<span onClick={() => toggleEdit('sexo')} className="clickable"><i className="fas fa-venus-mars"></i> {paciente?.sexo}</span>
            }

            {(errors && errors['paciente.sexo']) && (
                <small className='help-blockParams form-Text'>
                    Este Campo es requerido.<br/>
                </small>
            )}
        </div>
        <div className="col">
            {editando.grupo_sanguineo
                ? <select ref={grupoSanguineoRef} className="form-control" value={paciente?.grupo_sanguineo ?? ''} onChange={(e) => onChange({...paciente, grupo_sanguineo: e.target.value})} onBlur={() => toggleEdit('grupo_sanguineo')}>
                    {!paciente?.grupo_sanguineo && <option value="">Seleccionar...</option>}
                    <option value="A+">A+</option>
                    <option value="A-">A-</option>
                    <option value="AB+">AB+</option>
                    <option value="AB-">AB-</option>
                    <option value="B+">B+</option>
                    <option value="B-">B-</option>
                    <option value="O+">O+</option>
                    <option value="O-">O-</option>
                </select>
                :<span onClick={() => toggleEdit('grupo_sanguineo')} className="clickable"><i className="fas fa-tint"></i> {paciente?.grupo_sanguineo}</span>
            }

            {(errors && errors['paciente.grupo_sanguineo']) && (
                <small className='help-blockParams form-Text'>
                    Este Campo es requerido.<br/>
                </small>
            )}
        </div>
    </>;
};

export default PacienteableInfo;